import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../Components/Header";
import SimpleTable from "../Components/SimpleTable";
import { BRAND } from "../css/brand";
import { RefreshCw } from "lucide-react";
import BlueButton from "../Components/BlueButton";
import Loader from "../Components/Loader";
import GoBackButton from "../Components/GoBackButton";
import TableSkeleton from "../Components/TableSkeleton";

export default function Inventory({
  receiverId: propReceiverId,
  companyId: propCompanyId,
  role: propRole,
  compact = false, // hide header/pagination if true
}) {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // ✅ Default values from session (for standalone use)
  const authUserString = sessionStorage.getItem("authUserData1");
  const authUser = authUserString ? JSON.parse(authUserString) : null;
  const sessionId = authUser?.data?.[0]?.id;
  const sessionCompany = authUser?.data?.[0]?.company_id;
  const sessionRole = authUser?.data?.[0]?.role;

  // ✅ Use props if provided, otherwise fallback to session
  const receiver_id = propReceiverId || sessionId;
  const company_id = propCompanyId || sessionCompany;
  const userRole = propRole || sessionRole;

  
    const fetchInventory = async () => {
      setLoading(true);
      setError(null);

      let finalCompanyId = receiver_id; // default for role = 2

      if ([3, 4, 5, 6,7 ].includes(userRole)) {
        finalCompanyId = company_id;
      }

      try {
        const res = await axios.get(
          `https://spillas.com/api/v1/keys/all-my-package-list?receiver_id=${receiver_id}&company_id=${finalCompanyId}`
        );

        const data = res.data.data || [];

        const rows = data.map((item) => [
          item.key_type === 1 ? "Regular Key" : "Smart Key",
          item.package_name || "-",
          item.qty || 0,
          item.total_assigned_qty || 0,
          item.qty || 0,
        ]);

        setInventory(rows);
      } catch (err) {
        console.error("Failed to fetch inventory:", err);
        setError("Failed to load inventory data.");
      } finally {
        setLoading(false);
      }
    };
useEffect(() => {
    if (receiver_id && company_id) {
      fetchInventory();
    }
  }, [receiver_id, company_id, userRole]);

  const totalPages = Math.ceil(inventory.length / rowsPerPage);
  const paginate = (array, page) =>
    array.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <div className={compact ? "space-y-2" : "space-y-4"}>
      <GoBackButton/>
      {!compact && <Header brand={BRAND} title="Inventory" />}
      <div className="flex justify-end">
        <BlueButton brand={BRAND} onClick={() => {fetchInventory()}} className="inline-flex items-center gap-1">
        <RefreshCw size={14} /> Refresh
      </BlueButton>
      </div>

        {loading ? (
            <TableSkeleton rows={6} cols={5} />
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : inventory.length === 0 ? (
            <p>No Pacakges found</p>
          ) : (
            <>
            <SimpleTable
              headers={["Product", "Model/Package", "In Stock", "Allocated", "Available"]}
              rows={paginate(inventory, page)}
            />
            </>
          )}

        <div className="flex gap-2 justify-end mt-4 items-center">
          {/* Prev Button */}
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            className={`px-2 py-1 border rounded text-sm ${
              currentPage === 1
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-white hover:bg-slate-100"
            }`}
          >
            Prev
          </button>

          {/* Page numbers */}
          {(() => {
            const pages = [];
            const maxVisible = 5; // show up to 5 pages
            let start = Math.max(1, currentPage - 2);
            let end = Math.min(totalPages, start + maxVisible - 1);

            if (end - start < maxVisible - 1) {
              start = Math.max(1, end - maxVisible + 1);
            }

            if (start > 1) {
              pages.push(1);
              if (start > 2) pages.push("...");
            }

            for (let i = start; i <= end; i++) {
              pages.push(i);
            }

            if (end < totalPages) {
              if (end < totalPages - 1) pages.push("...");
              pages.push(totalPages);
            }

            return pages.map((p, idx) =>
              p === "..." ? (
                <span key={idx} className="px-2 text-gray-500">
                  ...
                </span>
              ) : (
                <button
                  key={p}
                  onClick={() => setCurrentPage(p)}
                  className={`px-2 py-1 border rounded text-sm ${
                    currentPage === p
                      ? "bg-blue-600 text-white"
                      : "bg-white hover:bg-slate-100"
                  }`}
                >
                  {p}
                </button>
              )
            );
          })()}

          {/* Next Button */}
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            className={`px-2 py-1 border rounded text-sm ${
              currentPage === totalPages
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-white hover:bg-slate-100"
            }`}
          >
            Next
          </button>
        </div>
    </div>
  );
}


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../Components/Header";
// import SimpleTable from "../Components/SimpleTable";
// import { BRAND } from "../css/brand";

// export default function Inventory() {
//   const [inventory, setInventory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Pagination
//   const [page, setPage] = useState(1);
//   const rowsPerPage = 10;

//   const authUserString = sessionStorage.getItem("authUserData1");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.data[0]?.id;
//   const companyID = authUser?.data[0]?.company_id;
//   const userRole = authUser?.data[0]?.role;

//   useEffect(() => {
//     const fetchInventory = async () => {
//       setLoading(true);
//       setError(null);

//       // Determine receiver_id and company_id based on role
//       let receiver_id = loginUserID;
//       let company_id = loginUserID; // default for role = 2

//       if ([3, 4, 5, 6].includes(userRole)) {
//         company_id = companyID; // use company_id from session
//       }

//       try {
//         const res = await axios.get(
//           `https://spillas.com/api/v1/keys/all-my-package-list?receiver_id=${receiver_id}&company_id=${company_id}`
//         );

//         const data = res.data.data || [];

//         const rows = data.map((item) => [
//           item.key_type === 1 ? "Regular Key" : "Smart Key",
//           item.package_name || "-",
//           item.qty || 0,
//           item.total_assigned_qty || 0,
//           item.qty || 0,
//         ]);

//         setInventory(rows);
//       } catch (err) {
//         console.error("Failed to fetch inventory:", err);
//         setError("Failed to load inventory data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (loginUserID && companyID) {
//       fetchInventory();
//     }
//   }, [loginUserID, companyID, userRole]);

//   // Pagination helpers
//   const totalPages = Math.ceil(inventory.length / rowsPerPage);
//   const paginate = (array, page) =>
//     array.slice((page - 1) * rowsPerPage, page * rowsPerPage);

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Inventory" />

//       {loading && <p>Loading...</p>}
//       {error && <p className="text-red-500">{error}</p>}

//       {!loading && !error && (
//         <>
//           <SimpleTable
//             headers={["Product", "Model/Package", "In Stock", "Allocated", "Available"]}
//             rows={paginate(inventory, page)}
//           />

//           {/* Pagination controls */}
//           <div className="flex justify-center gap-2 mt-2">
//             <button
//               disabled={page === 1}
//               onClick={() => setPage(page - 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Prev
//             </button>
//             <span>{page} / {totalPages}</span>
//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(page + 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../Components/Header";
// import SimpleTable from "../Components/SimpleTable";
// import { BRAND } from "../css/brand";

// export default function Inventory() {
//   const [inventory, setInventory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Pagination
//   const [page, setPage] = useState(1);
//   const rowsPerPage = 10;

//   const authUserString = sessionStorage.getItem("authUserData1");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.data[0]?.id;

//   useEffect(() => {
//     const fetchInventory = async () => {
//       try {
//         const res = await axios.get(
//           `https://spillas.com/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}&page=${page}`
//         );

//         const data = res.data.data || [];

//         const rows = data.map((item) => [
//           item.key_type === 1 ? "Regular Key" : "Smart Key",
//           item.package_name,
//           item.qty,
//           item.total_assigned_qty,
//           item.balance_keys,
//         ]);

//         setInventory(rows);
//       } catch (err) {
//         console.error("Failed to fetch inventory:", err);
//         setError("Failed to load inventory data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInventory();
//   }, [loginUserID]);

//   // Pagination helpers
//   const totalPages = Math.ceil(inventory.length / rowsPerPage);
//   const paginate = (array, page) =>
//     array.slice((page - 1) * rowsPerPage, page * rowsPerPage);

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Inventory" />

//       {loading && <p>Loading...</p>}
//       {error && <p className="text-red-500">{error}</p>}

//       {!loading && !error && (
//         <>
//           <SimpleTable
//             headers={["Product", "Model/Package", "In Stock", "Allocated", "Available"]}
//             rows={paginate(inventory, page)}
//           />

//           {/* Pagination controls */}
//           <div className="flex justify-center gap-2 mt-2">
//             <button
//               disabled={page === 1}
//               onClick={() => setPage(page - 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Prev
//             </button>
//             <span>{page} / {totalPages}</span>
//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(page + 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// import Header from "../Components/Header";
// import { BRAND } from "../css/brand";
// import SimpleTable from "../Components/SimpleTable";

// export default function Inventory() {
//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Inventory" />
//       <SimpleTable headers={["Product", "Model/Package", "In Stock", "Allocated", "Available"]} rows={[["Regular Key", "Regular + Warranty", "180", "120", "60"],["Smart Key", "Smart Key", "170", "130", "40"]]} />
//     </div>
//   );
// }